const Spin = () => {
  return <span className="spin"></span>
}

export default Spin
